export enum EnumTipoUsoPWR {
  PWR_USO_Ind = 6,
  PWR_USO_Otros,
  PWR_USO_05_85,
  PWR_USO_85_SL,
  PWR_USO_100 = 12,
  PWR_USO_Exc_SL,
  PWR_USO_1_85
}
